import { useForm } from "../../hooks/useForm";
import {
  useExpirePassMutation,
  useLazyValidarSesionQuery,
  useLoginMutation,
  useValidarSesionQuery,
} from "../../services/docs";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../components/ui/Logo";
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { Alert, AlertDescription, AlertTitle } from "../../components/ui/Alert";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { agregarToken, iniciarSesion } from "../../features/ui/uiSlice";
import { Label } from "../../components/ui/Label";
import { Input } from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { Spinner } from "../../components/Spinner";

export const ExpireScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginSend, { isLoading, error, isSuccess, reset }] =
    useExpirePassMutation();
  const { formulario, handleInputChange } = useForm({
    password_actual: "",
    password_nueva: "",
    username: "",
  });
  const { password_actual, password_nueva, username } = formulario;
  const handleLogin = async (e: any) => {
    e.preventDefault();
    const resp = await loginSend({ ...formulario })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
          if (err.data.restablecer === 1) {
            navigate("/auth/expire", { replace: true });
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      toastr.info(resp.message);
      navigate("/auth/login", { replace: true });
    }
  };
  return (
    <>
      <div className="relative grid max-h-full min-h-full min-w-full max-w-full lg:grid-cols-1">
        <div
          className="fixed inset-0 !h-[100dvh] w-[53vw] bg-gradient-to-b from-primary to-primary-light"
          style={{
            clipPath: "polygon(0 0, 100% 0%, 88% 100%, 0% 100%)",
          }}
        >
          <img
            alt="insuranceservices pattern"
            src="/images/pattern2.png"
            width={1920}
            height={1080}
            sizes="(max-width: 639px) 100vw, (max-width: 1079px) 50vw, 1079px"
            className="opacity-1 inset-0 z-[1] h-full w-full object-cover"
          />
        </div>

        <div className="absolute left-1/2 top-1/2 w-full max-w-md -translate-x-1/2 translate-y-1/2">
          <div className="card flex max-h-full flex-col items-center justify-center space-y-4 overflow-y-auto rounded-xl">
            <img alt="pattern" src="/images/logoAXA.png" width="50%" />
            <form className="w-full space-y-6" action="#" method="POST">
              <div>
                <Label>Correo Electrónico:</Label>
                <Input
                  name="username"
                  value={username}
                  onChange={handleInputChange}
                  type="text"
                />
              </div>
              <div>
                <Label>Contraseña Actual:</Label>
                <Input
                  name="password_actual"
                  value={password_actual}
                  onChange={handleInputChange}
                  type="password"
                />
              </div>
              <div>
                <Label>Contraseña Nueva:</Label>
                <Input
                  name="password_nueva"
                  value={password_nueva}
                  onChange={handleInputChange}
                  type="password"
                />
              </div>
              <div></div>
              <div>
                {isLoading && (
                  <div className="flex w-full justify-center">
                    <Spinner />
                  </div>
                )}
                {!isLoading && (
                  <Button
                    size="lg"
                    className="w-full rounded-xl"
                    onClick={handleLogin}
                  >
                    Actualizar contraseña
                  </Button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
